const useStage = 'https://api-be3db5b.stage.prepairelabs.com/v1';

export const Endpoints = {
  publicSharedChat: `${useStage}/marketplace/grantai/gateway_pub/api/v1/public/chat/shared`
}